import { useState } from "react";
import { cn } from "@shared/lib/utils";
import type { HomeAgent } from "@/lib/homeAgents";

type AgentAvatarProps = {
  agent: HomeAgent;
  /** Size the avatar from the outside (e.g. "size-full", "size-5"). */
  className?: string;
};

/** Circular assistant portrait with a gradient-initial fallback when art is missing. */
export function AgentAvatar({ agent, className }: AgentAvatarProps) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div className={cn("grid place-items-center rounded-full bg-(--ty-bg-3)", className)}>
        <span className="font-mono text-[10px] font-medium text-ink/90">{agent.name.charAt(0)}</span>
      </div>
    );
  }

  return (
    <img
      src={agent.portrait}
      alt={agent.name}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
      className={cn("rounded-full object-cover", className)}
    />
  );
}
